<template>
  <div class="container">
      <div class="row topnav" style="padding-left: 15px;">
      </div>
      <div>
        <button  style="background-color: #656565;border: solid 2px;border-style: outset;text-align:left;color:whitesmoke;width:200px;height: 50px; margin-left: 20px;margin-right: 20px;text-align: center"  @click="handleMainPage" v-show="pos_ok">POS Page</button>
        <!--<button  style="background-color: #656565;border: solid 2px;border-style: outset;text-align:left;color:whitesmoke;width:200px;height: 50px; margin-left: 20px;margin-right: 20px;text-align: center" @click="handleAddCustomer">Customers</button>-->
        <button  style="background-color: #656565;border: solid 2px;border-style: outset;text-align:left;color:whitesmoke;width:200px;height: 50px; margin-left: 20px;margin-right: 20px;text-align: center" @click="handleFindInvoice" v-show="return_ok">Find invoice</button>
        <button  style="background-color: #656565;border: solid 2px;border-style: outset;text-align:left;color:whitesmoke;width:200px;height: 50px; margin-left: 20px;margin-right: 20px;text-align: center" @click="handleReports" v-show="reports_ok">Reports</button>

        <!--
        <li class="list-group-item" style="background-color: #656565;border: solid 2px;border-style: outset;text-align:left"><a style="color:whitesmoke"  onmouseover="this.style.backgroundColor='#656565'" href="#">Customers</a></li>
        <li class="list-group-item" style="background-color: #656565;border: solid 2px;border-style: outset;text-align:left"><a style="color:whitesmoke"  onmouseover="this.style.backgroundColor='#656565'" href="#" @click="handleFindInvoice">Find invoice</a></li>
        <li class="list-group-item" style="background-color: #656565;border: solid 2px;border-style: outset;text-align:left"><a style="color:whitesmoke"  onmouseover="this.style.backgroundColor='#656565'" href="#" @click="handleProductReturn">Return Invoice</a></li>
        <li class="list-group-item" style="background-color: #656565;border: solid 2px;border-style: outset;text-align:left"><a style="color:whitesmoke;" onmouseover="this.style.backgroundColor='#656565'" href="#" @click="handleReports">Reports</a></li>
        <table width="100%" align="center">
          <tr>
            <td>
              <li class="list-group-item" style="background-color: #656565;border: solid 2px;border-style: outset; outset;text-align:left"><a style="color:whitesmoke"  onmouseover="this.style.backgroundColor='#656565'" href="#" @click="handleAddCustomer">Customers</a></li>
            </td>
            <td>
              <li class="list-group-item" style="background-color: #656565;border: solid 2px;border-style: outset;text-align:left"><a style="color:whitesmoke"  onmouseover="this.style.backgroundColor='#656565'" href="#" @click="handleFindInvoice">Find invoice</a></li>
            </td>
            <td>
            </td>
          </tr>

          <tr>
            <td>
              <li class="list-group-item" style="background-color: #656565;border: solid 2px;border-style: outset;text-align:left"><a style="color:whitesmoke"  onmouseover="this.style.backgroundColor='#656565'" href="#" @click="handleProductReturn">Return Invoice</a></li>
            </td>
            <td>
              <li class="list-group-item" style="text-align:left; background-color: #656565;border: solid 2px;border-style: outset; outset;"><a  style="color:whitesmoke;" onmouseover="this.style.backgroundColor='#656565'" href="#" @click="handleReports">Reports</a></li>
            </td>
            <td>
            </td>
          </tr>          
        </table>
        -->
      </div>
  </div>
</template>
<script>
import commonServices from "@/shared/commonServices"
import ReportsMenu from "@/components/ReportsMenu"
export default {
    mixins: [commonServices],
    components : {ReportsMenu} ,
    mounted() {
      if(localStorage.pos_ok === "1"){
        this.pos_ok = true;
      }     
      if(localStorage.return_ok === "1"){
        this.return_ok = true;
      }     
      if(localStorage.reports_ok === "1"){
        this.reports_ok = true;
      }     
     
      this.language = 'ar';
      this.handleLanguage();
     
    },    
    data: function(){
        return {
            jsonData  : {},
            reports_ok: false,
            pos_ok: false,
            return_ok: false,
        }
    },
    methods:{
  handleMainPage() {
      this.$router.push({ name: 'main'} );
    },


  handleDailyTotals() {
      this.$router.push({ name: 'dailytotal'} );
    },

  handleDailySales() {
      this.$router.push({ name: 'dailysales'} );
    },

  handleItemsDaily() {
      this.$router.push({ name: 'itemsdaily'} );
    },

    }
  }
</script>
<style scoped>

</style>